<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>账号管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="add">
      <el-button type="primary" @click="addShow = true"
        >新增<i class="el-icon-upload el-icon--right"></i
      ></el-button>
    </div>
    <el-table :data="userData" style="width: 100%">
      <!-- <el-table-column label="用户 ID" prop="id"> </el-table-column> -->
      <el-table-column label="用户名称" prop="name"> </el-table-column>
      <el-table-column label="分配角色" prop="type"> </el-table-column>
      <el-table-column label="创建时间" prop="create_time"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="handleEdit(scope.row)"
            >修改</el-button
          >
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pagenum"
      :page-sizes="[1, 2, 5, 10]"
      :page-size="queryInfo.pagesize"
      layout="total, sizes, prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <!-- 添加角色 -->
    <el-dialog title="添加" :visible.sync="addShow">
      <el-form :model="addForm" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="用户名称" prop="short_name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="角色类型" prop="type">
          <el-select
            v-model="typeItem.type"
            value-key="id"
            placeholder="请选择角色类型"
            @change="typeChange(typeItem)"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.type"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择区域">
          <el-cascader
            v-model="district"
            :options="options1"
            :props="Props"
            @change="handleChange"
          >
            <template slot-scope="{  data }">
              <span>{{ data.district }}</span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item label="分配公司">
          <el-select
            v-model="addForm.mechanism_id"
            filterable
            remote
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.mechanism_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
		<el-form-item label="绑定用户">
		  <el-select
		    v-model="addForm.user_id"
		    filterable
		    remote
		    placeholder="请输入关键词"
		    :remote-method="remoteMethod1"
		  >
		    <el-option
		      v-for="(item,index) in user_iddata"
		      :key="index"
		      :label="item.login_name"
		      :value="item.user_id"
		    >
		    </el-option>
		  </el-select>
		</el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="newuser"
            >新增用户</el-button
          >
          <el-button >绑定用户</el-button>
        </el-form-item> -->
        <el-form-item label="账号" prop="login_name">
          <el-input v-model="addForm.login_name"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pwd">
          <el-input v-model="addForm.pwd"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitAddForm('form')"
            >立即添加</el-button
          >
          <el-button @click="addShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog :visible.sync="editShow">
      <el-form :model="editFrom" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="用户名称" prop="short_name">
          <el-input v-model="editFrom.name"></el-input>
        </el-form-item>
        <el-form-item label="角色类型" prop="type">
          <el-select
            v-model="typeItem.type"
            value-key="id"
            placeholder="请选择角色类型"
            @change="typeChange(typeItem)"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.type"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分配公司">
          <el-select
            v-model="editFrom.mechanism_id"
            filterable
            remote
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.mechanism_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
		<el-form-item label="绑定用户">
		  <el-select
		    v-model="editFrom.user_id"
		    filterable
		    remote
		    placeholder="请输入关键词"
		    :remote-method="remoteMethod1"
		  >
		    <el-option
		      v-for="(item,index) in user_iddata"
		      :key="index"
		      :label="item.login_name"
		      :value="item.user_id"
		    >
		    </el-option>
		  </el-select>
		</el-form-item>
        <el-form-item label="账号" prop="login_name">
          <el-input v-model="editFrom.login_name"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pwd">
          <el-input v-model="editFrom.pwd"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitEditForm('form')"
            >立即修改</el-button
          >
          <el-button @click="addShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
	<el-dialog :visible.sync="userShow">
	  <el-form :model="userFrom" :rules="rules" ref="form" label-width="80px">
	    <el-form-item label="用户账号" prop="login_name">
	      <el-input v-model="userFrom.login_name"></el-input>
	    </el-form-item>
	    <el-form-item label="用户密码" prop="pwd">
	      <el-input v-model="userFrom.pwd"></el-input>
	    </el-form-item>
	  </el-form>
	  <span slot="footer" class="dialog-footer">
	      <el-button type="primary" @click="userShow = false">确 定</el-button>
	    </span>
	</el-dialog>
  </div>
</template>
<script>
export default {
  name: "role",
  data() {
    return {
		userShow:false,
      addShow: false,
      editShow: false,
      options: [],
      value: "",
      list: [],
      typeItem: {},
      loading: false,
      // 用户列表
      userData: [],
      total: 0,
      // 角色列表
      typeList: [],
      // 获取用户列表的参数对象
      queryInfo: {
        query: "",
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10,
      },
      addForm: {
		  user_id:'',
        name: "",
        type: "",
        pwd: "",
        login_name: "",
      },
      editFrom: {
		  user_id:'',
        id: "",
        name: "",
        type: "",
        pwd: "",
        login_name: "",
        mechanism_id: "",
      },
	  userFrom:{
		  pwd: "",
		  login_name: "",
	  },
      rules: {
        name: [
          { required: true, message: "请输入用户名称", trigger: "blur" },
          { min: 2, max: 9, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择角色", trigger: "change" }],
        login_name: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { min: 3, message: "长度在 3 个字符以上", trigger: "blur" },
        ],
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 3, message: "长度在 3 个字符以上", trigger: "blur" },
        ],
      },
      options1: [],
      district:[],
      Props: {
        children: "childrens",
        value: "district",
        label: "district",
      },
      dd:{},
	  user_iddata:[]
    };
  },
  mounted: function () {
    this.getList();
    this.getRoleList();
    this.GetcityList();
  },
  methods: {
	  newuser(){
		this.userShow = true  
	  },
    handleChange(value) {
      this.district = value;
      console.log(this.district);
    },
    GetcityList() {
      // console.log(this.nettime)
     this.$fetch("/user/district/query")
        .then((res) => {
          this.options1 = res.data[0].childrens;
          console.log(12, this.options1);
        });
    },
    typeChange(e) {
      if (this.addShow == true) {
        this.addForm.type = e.type.type;
        this.addForm.levels = e.type.levels;
        this.addForm.admin_id = e.type.admin_id;
        console.log(this.addForm);
        this.dd = e.type
      }
      if (this.editShow == true) {
        this.editFrom.type = e.type.type;
        this.editFrom.levels = e.type.levels;
        this.editFrom.admin_id = e.type.admin_id;
        console.log(this.editFrom);
      }
    },
    remoteMethod(query) {
      this.chaxun(query);
    },
	remoteMethod1(query) {
	  this.getuser(query);
	},

    // 机构查询
    chaxun(item) {
      if (item != "") {
        console.log(item);
        // type=teach_paypal&
        let url =
          "/user/mastermechanism/queryMechanismByType?mechanism_name=" +
          item;
        this.$fetch(url).then((res) => {
          console.log(res.data);
          this.options = res.data;
        });
      } else {
        this.options = [];
      }
    },
	// 用户模糊查询
	getuser(item) {
	  if (item != "") {
	    console.log(item);
	    let url =
	      "/user/user/queryByMessage?login_name=" +
	      item;
	    this.$fetch(url).then((res) => {
	      console.log(res.data);
	      this.user_iddata = res.data.rows;
	    });
	  } else {
	    this.user_iddata = [];
	  }
	},
    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getList();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getList();
    },
    // 用户列表
    getList() {
      this.$fetch(
        "/authorization/managerUser/queryManagerListPage?status=2&pageSize=" +
          this.queryInfo.pagesize +
          "&currentPage=" +
          this.queryInfo.pagenum
      ).then((res) => {
        if (res.code == 0) {
          this.userData = res.data.rows;
          this.total = res.data.total;
        } else {
          this.$message({
            message: res.message,
          });
        }
      });
    },
    getRoleList() {
      this.$fetch("/authorization/managerIdentity/queryRoleList?state=1&pageSize=200").then(
        (res) => {
          this.typeList = res.data.rows;
          console.log("类型", this.typeList);
        }
      );
    },
    // 打开修改窗 获取修改信息
    handleEdit(row) {
      console.log(row);
      this.editFrom.id = row.id;
      this.editFrom.name = row.name;
      this.typeItem.type = row.type;
      this.editFrom.pwd = row.pwd;
      this.editFrom.levels = row.levels;
      this.editFrom.admin_id = row.admin_id;
      this.editFrom.login_name = row.login_name;
      this.editFrom.user_id = row.user_id;
      this.editShow = true;
    },
    // 删除
    handleDelete(row) {
      // 弹框询问用户是否直接删除数据
      let data = {};
      data.id = row.id;
      data.status = 1;
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$post("/authorization/managerUser/update", data).then((res) => {
            if (res.code != 0) {
              return this.$message.error("删除用户失败!");
            } else {
              this.getList();
              return this.$message.success("删除用户成功!");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 添加
    submitAddForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data =this.addForm
          data.province =this.district[0]
          data.city = this.district[1]
           data.identity_id = this.dd.id
           data.levels = this.dd.levels
          this.$post("/authorization/managerUser/insert", data).then(
            (res) => {
              console.log(res);
              if (res.code == 0) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getList();
                this.addShow = false;
                this.addForm = {};
              } else {
                this.$message({
                  message: res.message,
                });
              }
            }
          );
        } else {
          this.$message({
            message: "表单验证失败",
            type: "warning",
          });
          return false;
        }
      });
    },
    // 修改
    submitEditForm(formName) {
      // this.$refs[formName].validate((valid) => {
        // if (valid) {
          this.$post("/authorization/managerUser/insert", this.editFrom).then(
            (res) => {
              console.log(res);
              if (res.code == 0) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.getList();
                this.editShow = false;
              } else {
                this.$message({
                  message: res.message,
                });
              }
            }
          );
        // } else {
        //   this.$message({
        //     message: "表单验证失败",
        //     type: "warning",
        //   });
        //   return false;
        // }
      // });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style scoped>
.add {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/guanli/root.vue